import { useState } from "react";
import styled from "styled-components";

import { Box } from "@vinomofo/components";

import { DividerLink } from "../../divider-link";
import { Dealer, DealerCard } from "../dealer-card";

const DealerCardWrapper = styled(Box)`
  overflow-x: scroll;

  @media ${({ theme }) => theme.mq.min.tablet} {
    overflow-x: auto;
  }
`;

export type FeaturedDealerProps = {
  dealers: Array<Dealer>;
};

export const FeaturedDealers = ({
  dealers,
}: FeaturedDealerProps): JSX.Element => {
  const [currentPopover, setCurrentPopover] = useState<number>(undefined);

  return (
    <DealerCardWrapper mx={[-20, -35, 0]} paddingBottom={4}>
      <Box
        width={["min-content", "auto"]}
        px={[62.5, 0]}
        display="grid"
        gridTemplateColumns={[
          "repeat(4, 1fr)",
          "repeat(2, 1fr)",
          "repeat(4, 1fr)",
        ]}
        gridGap={["40px", "40px 0"]}
        mb={4}
      >
        {dealers.map((dealer, i) => (
          <DealerCard
            key={i}
            dealer={dealer}
            isOpen={currentPopover === i}
            toggleOpen={() =>
              currentPopover === i
                ? setCurrentPopover(undefined)
                : setCurrentPopover(i)
            }
          />
        ))}
      </Box>
      <DividerLink to="/dealers/" label="Meet the dealers" />
    </DealerCardWrapper>
  );
};
